import type { ObjectId } from "@bbj-types/utils";
import { useCallback } from "react";
import { useAxiosDiagnosis } from "./axios";
import type { IDiagnosis } from "./types";

export type TImportedFtDiagnosis = Pick<
  IDiagnosis,
  "_id" | "completed" | "updatedAt" | "externalIntegrations" | "origin"
>;

export interface IImportFtDiagnosesResponse {
  imported: TImportedFtDiagnosis[];
  skipped: number;
}

export const useImportCandidateFtDiagnoses = () => {
  const [state, execute, cancel] = useAxiosDiagnosis<IImportFtDiagnosesResponse, void, unknown>(
    {
      method: "POST",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (candidateId: ObjectId) =>
      execute({
        url: `/import/ft/${candidateId}`,
      }),
    [execute]
  );

  return [state, callback, cancel] as const;
};
